import { render } from "./ProgramTrackEditItemPane.vue?vue&type=template&id=13ec2467&scoped=true&ts=true"
import script from "./ProgramTrackEditItemPane.vue?vue&type=script&lang=ts"
export * from "./ProgramTrackEditItemPane.vue?vue&type=script&lang=ts"

import "./ProgramTrackEditItemPane.vue?vue&type=style&index=0&id=13ec2467&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ec2467"]])

export default __exports__